var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "modal-bg amap-sug-result" },
        [
          _c(
            "AppDialog",
            {
              attrs: {
                title: "文件预览",
                "append-to-body": false,
                loading: _vm.loading,
                height: "auto",
                width: "100vw",
                top: _vm.top,
              },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "txtPreview overflowOuto",
                },
                [
                  _vm.fileType === "txt"
                    ? [_vm._v(" " + _vm._s(_vm.value) + " ")]
                    : [
                        _c("iframe", {
                          staticStyle: { border: "none" },
                          attrs: {
                            src: _vm.src,
                            width: "100%",
                            height: "100%",
                          },
                        }),
                      ],
                ],
                2
              ),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }